import React from 'react';
import style from './style.module.scss';
import cn from 'classnames';

export default function Button(props) {
    const {
        // PROPS
        wrapperClass,
        iconClass,
        text,
        children,
        icon,
        iconAlignStart = false,
        preventDefault = false,
        stopPropagation = false,

        // EVENTS
        onClick,

        // STYLES
        // --sizes--
        primary,
        compact,
        small,
        // --colors--
        light,
        green,
        dark,
        gray,
        gradient,
        // --misc--
        outline,
        round
    } = props;

    const buttonIcon = icon && getIconLayout(icon, iconAlignStart, iconClass);

    return (
        <button
            onClick={e => handleClick(e, onClick, preventDefault, stopPropagation)}
            className={cn(style.button, wrapperClass, {
                [style.buttonCompact]: compact,
                [style.buttonPrimary]: primary,
                [style.buttonSmall]: small,
                [style.buttonDark]: dark,
                [style.buttonGreen]: green,
                [style.buttonLight]: light,
                [style.buttonGray]: gray,
                [style.buttonGradient]: gradient,
                [style.buttonOutline]: outline,
                [style.buttonRound]: round,
            })}
            text={text}
        >
            {iconAlignStart && buttonIcon}
            {text}
            {children}
            {!iconAlignStart && buttonIcon}
        </button>
    )
}

function handleClick(e, callback, preventDefault, stopPropagation) {
    if (preventDefault) {
        e.preventDefault();
    }

    if (stopPropagation) {
        e.stopPropagation();
    }

    if (callback) {
        callback(e);
    }
}

function getIconLayout(icon, alignStart, iconClass) {
    const iconClassName = cn(style.icon, iconClass, {
        [style.iconAlignStart]: alignStart,
    });

    if (typeof icon === 'string') {
        return (
            <img
                className={iconClassName}
                src={icon}
                alt={'icon'}
            />
        )
    }

    return (
        <span className={iconClassName}>
            {icon}
        </span>
    )
}